/* eslint-disable filename-export/match-default-export */

// The package root eagerly includes ReactAce's unrelated split and diff implementations.
import ReactAceEditor from 'react-ace/lib/ace';

import 'ace-builds/src-noconflict/theme-chrome';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/mode-lua';
import 'ace-builds/src-noconflict/mode-yaml';

import './ace-theme.scss';

export default ReactAceEditor;
